import { render } from "./JapaneseInput-xs.vue?vue&type=template&id=050dfff3&ts=true"
import script from "./JapaneseInput-xs.vue?vue&type=script&lang=ts"
export * from "./JapaneseInput-xs.vue?vue&type=script&lang=ts"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__